import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTable } from '@result/result-ui-components/src/hooks/table/tableHook';
import Table from '@result/result-ui-components/src/components/Table';
import TablePagination from '@result/result-ui-components/src/components/TablePagination';
import { useDispatch, useSelector } from 'react-redux';
import Filter from './Filter';
import Button from '@result/result-ui-components/src/components/Button';

const TableWithFilter = (props) => {
	const { columns, onClick } = props;
	const { t } = useTranslation();
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const tableData = useSelector(props.selector);

	const {
		selection,
		onSelection,
		page,
		onPage,
		sort,
		onSort,
		onFilter,
		filter,
	} = useTable(
		{
			page: 0,
			filter: props.defaultFilter,
			total: tableData?.totalElements,
			data: tableData ? tableData : { content: [] },
			sort: props.defaultSort,
		},
		onRowClick,
		fetchData
	);

	function onRowClick(entry) {
		if (props.disableOnClick) {
			return;
		}
		onClick ? onClick() : navigate(t('navigation.href.edit') + '/' + entry.id);
	}

	function fetchData(page, filter, sort) {
		let params = { page: page, filter: filter, sort: sort };
		if (props?.fetchId) {
			params.id = props.fetchId;
		}
		dispatch(props.fetchAction(params))
			.then(async () => {
				if (props.refetchData) props.onDataRefetched();
			})
			.catch(async () => {
				if (props.refetchData) props.onDataRefetched();
			});
	}

	useEffect(() => {
		if (props.refetchData) fetchData(page, filter, sort);
	}, [props.refetchData]);

	return (
		<div>
			<div className="card table-card has-overflow-y-auto">
				<div className="is-flex is-justify-content-space-between is-align-items-start p-4">
					{props.showCreateButton && (
						<Button
							color="primary"
							label={props.createButtonLabel || t('create_new')}
							onClick={() => navigate(t('navigation.href.create'))}
						/>
					)}
					{props.filterColumns && props.filterColumns.length > 0 && (
						<Filter
							columns={props.filterColumns}
							filter={filter}
							onFilter={(filter, formValues) => {
								onFilter(filter);
								if(props.onFilter) {
									props.onFilter(filter, formValues);
								}
							}}
							initialFilter={props.initialFilter}
							filterIcon={props.filterIcon}
						/>
					)}
				</div>
				<div className="card-content">
					<Table
						columns={columns}
						data={tableData?.content ? tableData.content : []}
						onSelection={!props?.disableOnClick ? onSelection : () => {}}
						selection={!props?.disableOnClick ? selection : {}}
						onSort={!props.groupRowsBy ? onSort : null}
						sort={sort}
						groupRowsBy={props.groupRowsBy}
					/>
					<div className="table-pagination">
						<TablePagination
							page={page.page}
							total={page.total || tableData?.totalElements}
							pageSize={page.size}
							onPage={onPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

TableWithFilter.propTypes = {
	selector: PropTypes.func.isRequired,
	fetchAction: PropTypes.func.isRequired,
	columns: PropTypes.array.isRequired,
	onClick: PropTypes.func,
	disableOnClick: PropTypes.bool,
	createButtonLabel: PropTypes.string,
	showCreateButton: PropTypes.bool,
	defaultSort: PropTypes.string,
	groupRowsBy: PropTypes.string,
	filterColumns: PropTypes.arrayOf(PropTypes.object),
	defaultFilter: PropTypes.string,
	onFilter: PropTypes.func,
	initialFilter: PropTypes.object,
};

export default TableWithFilter;
